/**
 * Иконки сезонности и шипов. Inline SVG, чтобы не зависеть от CDN.
 */

export function SeasonSun() {
  return (
    <svg class="season-svg" viewBox="0 0 32 32" aria-hidden="true">
      <circle cx="16" cy="16" r="6" fill="#F59E0B" />
      <g stroke="#F59E0B" stroke-width="2.5" stroke-linecap="round">
        <line x1="16" y1="2" x2="16" y2="7" />
        <line x1="16" y1="25" x2="16" y2="30" />
        <line x1="2" y1="16" x2="7" y2="16" />
        <line x1="25" y1="16" x2="30" y2="16" />
        <line x1="5.1" y1="5.1" x2="8.6" y2="8.6" />
        <line x1="23.4" y1="23.4" x2="26.9" y2="26.9" />
        <line x1="5.1" y1="26.9" x2="8.6" y2="23.4" />
        <line x1="23.4" y1="8.6" x2="26.9" y2="5.1" />
      </g>
    </svg>
  );
}

const SNOW_PATH = (
  <path
    d="M60.5 30.5h-6.9l4.2-4.2c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0l-6.3 6.3h-4.7l2.5-2.5c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0l-4.6 4.6h-4.8l9-9h8.9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-5.9l5.5-5.5c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0l-5.5 5.5v-5.9C45.5 9.6 44.9 9 44 9s-1.5.7-1.5 1.5v8.9l-9 9v-4.8l4.6-4.6c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0l-2.5 2.5v-4.7l6.3-6.3c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0l-4.2 4.2v-7c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v6.9l-4.2-4.2c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l6.3 6.3v4.7L28 16.8c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l4.6 4.6v4.8l-9-9v-8.9c0-.8-.7-1.4-1.5-1.4s-1.5.7-1.5 1.5v5.9L13 10.9c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l5.5 5.5h-5.9c-.9 0-1.5.6-1.5 1.5s.7 1.5 1.5 1.5h8.9l9 9h-4.8L19 25.9c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l2.5 2.5h-4.7l-6.3-6.3c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l4.2 4.2h-7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h6.9l-4.2 4.2c-.6.6-.6 1.5 0 2.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4l6.3-6.3h4.7L16.8 36c-.6.6-.6 1.5 0 2.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4l4.6-4.6h4.8l-9 9h-8.9c-.9 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5.9L10.9 51c-.6.6-.6 1.5 0 2.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4l5.5-5.5v5.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-8.9l9-9v4.8L25.9 45c-.6.6-.6 1.5 0 2.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4l2.5-2.5v4.7l-6.3 6.3c-.6.6-.6 1.5 0 2.1c.3.3.7.4 1.1.4s.8-.1 1.1-.4l4.2-4.2v6.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-6.9l4.2 4.2c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1l-6.3-6.3v-4.7l2.5 2.5c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1l-4.6-4.6v-4.8l9 9v8.9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-5.9l5.5 5.5c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1l-5.5-5.5H54c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-8.9l-9-9h4.8l4.6 4.6c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1l-2.5-2.5h4.7l6.3 6.3c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1l-4.2-4.2h6.9c.8 0 1.5-.7 1.5-1.5s-1.3-1.5-2.1-1.5"
    fill="#09a7d9"
  />
);

export function SeasonSnow() {
  return (
    <svg class="season-svg" viewBox="0 0 64 64" aria-hidden="true">
      {SNOW_PATH}
    </svg>
  );
}

export function SeasonAll() {
  return (
    <svg class="season-svg" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <clipPath id="asl">
          <rect x="0" y="0" width="31" height="64" />
        </clipPath>
        <clipPath id="asr">
          <rect x="33" y="0" width="32" height="64" />
        </clipPath>
      </defs>
      <g clip-path="url(#asl)">
        <circle cx="32" cy="32" r="12" fill="#F59E0B" />
        <g stroke="#F59E0B" stroke-width="5" stroke-linecap="round">
          <line x1="32" y1="4" x2="32" y2="14" />
          <line x1="32" y1="50" x2="32" y2="60" />
          <line x1="4" y1="32" x2="14" y2="32" />
          <line x1="10.2" y1="10.2" x2="17.3" y2="17.3" />
          <line x1="10.2" y1="53.8" x2="17.3" y2="46.7" />
        </g>
      </g>
      <g clip-path="url(#asr)">{SNOW_PATH}</g>
      <line x1="32" y1="0" x2="32" y2="64" stroke="#999" stroke-width="1" stroke-dasharray="3,3" />
    </svg>
  );
}

export function StudIcon() {
  return (
    <svg class="season-svg stud-svg" viewBox="0 0 32 32" aria-hidden="true">
      <polygon
        points="16,2 30,28 2,28"
        fill="none"
        stroke="#DC2626"
        stroke-width="2.5"
        stroke-linejoin="round"
      />
      <text
        x="16"
        y="24"
        text-anchor="middle"
        font-size="14"
        font-weight="bold"
        fill="#222"
        font-family="Arial,sans-serif"
      >
        Ш
      </text>
    </svg>
  );
}

export function PdfIcon() {
  return (
    <svg
      class="pdf-icon"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#E2E5E7"
        d="M2,0 L13,0 L20,7 L20,20 C20,21.1 19.1,22 18,22 L2,22 C0.9,22 0,21.1 0,20 L0,2 C0,0.9 0.9,0 2,0 Z"
      />
      <path fill="#B0B7BD" d="M13,0 L20,7 L13,7 Z" />
      <path fill="#CAD1D8" d="M14,7 L20,7 L14,1 Z" />
      <rect fill="#C82333" x="0" y="11" width="17" height="7" rx="1" />
      <text
        x="8.5"
        y="16.5"
        font-family="Arial,Helvetica,sans-serif"
        font-size="5"
        font-weight="bold"
        fill="#FFFFFF"
        text-anchor="middle"
      >
        PDF
      </text>
    </svg>
  );
}
